// src/services/cylinderMasterApi.js
import api from "./axiosInstance"; // correct file name

/**
 * 🔹 Create Cylinder
 * POST /api/v1/cylinderMaster/0
 */
export const createCylinder = (data) => {
  return api.post("cylinderMaster/0", data);
};

/**
 * 🔹 Get Cylinder by ID
 * GET /api/v1/cylinderMaster/{id}
 */
export const getCylinderById = (id) => {
  return api.get(`cylinderMaster/${id}`);
};

/**
 * 🔹 Search Cylinders (Pagination + Filters)
 * GET /api/v1/cylinderMaster/cylinders
 */
export const getCylinders = (params = {}) => {
  console.log("DEBUG: Params:", params);
  
  // Add default sorting if not provided
  const queryParams = {
    sortBy: 'id',
    direction: 'DESC',
    ...params
  };
  
  return api.get("cylinderMaster/cylinders", {
    params: queryParams
  });
};

/**
 * 🔹 Update Cylinder
 * PUT /api/v1/cylinderMaster/{id}
 */
export const updateCylinder = (id, data) => {
  return api.put(`cylinderMaster/${id}`, data);
};

/**
 * 🔹 Delete Cylinder
 * DELETE /api/v1/cylinderMaster/{id}
 */
export const deleteCylinder = (id) => {
  return api.delete(`cylinderMaster/${id}`);
};

/**
 * 🔹 Get SR Numbers (Autocomplete)
 * GET /api/v1/cylinderMaster/getSrno
 */
export const getSrNos = (cylinderName) => {
  return api.get("cylinderMaster/getSrno", {
    params: { cylinderName },
  });
};
